__webpack_require__.p = "/terminals2020/";